import React, { useState } from "react";
import ForgotPassword from "../component/ForgotPassword";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { postUserSendOtpService } from "../services/SignUpService";
import { Apinames } from "../utils/Apiname";
import { stat } from "fs";

const ForgotPasswordScreen = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

   const queryParams = new URLSearchParams(location.search);
  const fromApp = queryParams.get('fromApp');
  const onSendOtpPressed = async (email: string) => {
    try {
      setIsLoading(true);
      let data = { email };
      let response = await postUserSendOtpService(
        state !== null
          ? Apinames.signUpSendOtp
          : Apinames.forgotPasswordSendOtp,
        data
      );
      if (response.result.toLowerCase() === "success") {
        setIsLoading(false);
        if (state) {
          console.log("response  false::",);

          navigate("/otp", {
            state: {
              signupData: {
                ...state?.signupData,
                email,
                forgotPassword: false,
                fromApp:fromApp
              },
            },
          });
        } else {
          console.log("response  true::",);
          navigate("/otp", {
            state: { signupData: { email, forgotPassword: true,fromApp:fromApp } },
          });
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("onSendOtpPressed error ::", error);
      updateErrorMessage(error);
      setIsLoading(false);
    }
  };

  const updateErrorMessage = (error?: any) => {
    if (error) setErrorMessage(error);
    else setErrorMessage("");
  };
  return (
    <ForgotPassword
      errorMessage={errorMessage}
      isLoading={isLoading}
      onSendOtpPressed={onSendOtpPressed}
      updateErrorMessage={updateErrorMessage}
    />
  );
};

export default ForgotPasswordScreen;
